const clean = (arr) => {
  const result = [];
  for (let i = 0; i < arr.length; i += 1) {
    if (arr[i]) {
      if (typeof arr[i] === 'string') {
        if (arr[i].length > 0) {
          result.push(arr[i]);
        }
      } else {
        result.push(arr[i]);
      }
    }
  }
  return result;
}

export default clean;


// WEBPACK FOOTER //
// ./src/utils/clean.js